import TotalOccupancy from 'components/pages/stats/totaloccupancy';
import OccupancyRange from 'components/pages/stats/occupancyrange';
import DailyOccupancy from 'components/pages/stats/dailyoccupancy';
import OccupancyBreakDown from 'components/pages/stats/occupancybreakdown';

import React, { Component } from 'react';

class Charts extends Component {

    render() {
        return (
            <div className="stats-cards-wrapper">
                <TotalOccupancy currentNode={this.props.currentNode} querySettings={this.props.querySettings} />
                <OccupancyRange querySettings={this.props.querySettings} currentNode={this.props.currentNode} />
                <OccupancyBreakDown querySettings={this.props.querySettings} currentNode={this.props.currentNode} />
                <DailyOccupancy querySettings={this.props.querySettings} currentNode={this.props.currentNode} />
            </div>
        );
    }

}

export default Charts;



// WEBPACK FOOTER //
// ./src/components/pages/stats/charts.jsx